export const handleNavigation = (status: number) => {
  switch (status) {
    case 1:
    case 2: {
      return 'VerifyCustomerOtp'
    }
    case 3: {
      return 'CustomerBasicDetails'
    }
    case 4:
    case 6: {
      return 'CustomerBasicDetails'
    }
    case 5:
    case 7: {
      return 'BrandPage'
    }
    default:
      return
  }
}
